import React, { Component } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';
// import { $ } from 'jquery';
import { createRoute } from 'lib/util';

class CustomFields extends Component {
  valoresCustoms = [];

  render() {
    let {
      errors,
      handleCustomFieldChange,
      handleGroupChange,
      isSubmitted,
      t,
      values,
      groups,
      readOnly = false,
    } = this.props;

    let customFields = [];
    let visibles = customFields.filter((c) => !c.deleted);
    if (!values._custom) values._custom = [];
    if (!values._group) values._group = [];

    const groupSelected = (groupAnalize) => {
      let response = false;
      if (groupAnalize == undefined) return response;
      groups.some((group) => {
        if (
          (groupAnalize != undefined && group.id == groupAnalize._id) ||
          group.id == groupAnalize.id
        )
          return (response = group.id);
      });
      setCustomsByGroup(response);
      return response;
    };

    const dropDownSelected = (e, id) => {
      const { name, value } = e.target;
      buscarDependiente(name, value);
      handleCustomFieldChange(e); //Manejo de cambio de custom normal.
    };

    const buscarDependiente = (name, value) => {
      //dando name y value entrega id del dependiente
      return customFields.some((custom) => {
        if (custom.key == name) {
          return custom.elements.some((element) => {
            if (element.value == value) {
              return element;
            }
          });
        }
      });

      // this.valoresCustoms.
    };

    // Asignacion de value a campos a mostrar, esto debido a que element de customFields
    // originalmente es extraido de groups, por eso no tiene un value, el value de option
    // es el extraido del valor del usuario.
    const asignValueToCustomsFields = () => {
      customFields.forEach((element) =>
        values._custom.forEach((option) => {
          if (option.key == element.key) {
            element.value = option.value;
          }
        })
      );
    };

    // Se asignan los custom fields del documento, pero sin value.
    const setCustomsByGroup = (idGroup) => {
      let grupoSeleccionado = groups.filter((grupo) => grupo.id == idGroup);
      if (Array(grupoSeleccionado) && grupoSeleccionado.length > 0) {
        customFields = grupoSeleccionado[0].custom; //Esto cambiaro para que sea dinamico
        asignValueToCustomsFields();
      }
      // if(!customFields || customFields == undefined) customFields = [];
    };

    // si esta asignado un grupo, mostrar sus customs
    if (values._group.length > 0) {
      if (values._group[0]._id) {
        setCustomsByGroup(values._group[0]._id);
      } else {
        setCustomsByGroup(values._group[0].id);
      }
    }

    // No hace nada.
    values._custom.forEach((customValue) => {
      // Buscar customs seleccionados
      customFields.forEach((customShow) => {
        if (customShow.key == customValue.key) {
          //   console.log(customValue);
        }
      });
    });

    const getValueSelected = (drop, customEdit) => {
      const customFound = customFields.find((customShow) => {
        //Busca el custom dependiente
        if (customShow._id === drop) return customShow;
      });
      values._custom.forEach((customValue) => {
        if (customFound.key == customValue.key) {
          customFound.elements.forEach((valueSelected) => {
            if (valueSelected.value == customValue.value) {
              // Solo mostrar los siguientes opciones
              let elementosMostrar = [];
              customEdit.elements.forEach((elementoMostrar) => {
                if (elementoMostrar.dependent == valueSelected._id) {
                  elementosMostrar.push(elementoMostrar);
                }
              });
              customEdit.elementsShow = elementosMostrar;
            }
          });
        }
      });
    };

    customFields.forEach((customShow) => {
      customShow.elementsShow = customShow.elements; // Refrescar los valores a mostrar de cada custom
      if (customShow.state_dependent) {
        //Check if has dependent.
        getValueSelected(customShow.dependent, customShow);
      }
    });

    return (
      <div className="col-md-12 mt-3">
        <div className="row align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldSelect
              error={(isSubmitted && errors.group) || {}}
              name={'group'} //Nombre de como se guardara el Custom field
              label={t('employees.fields.group')}
              handleChange={handleGroupChange}
              value={groupSelected(values._group[0])}
              noEmptyOption={true}
              readOnly={readOnly}
            >
              <option value="null">{t('custom_field.empty')}</option>
              {groups.map((option) => (
                <option value={option.id}>{option.name}</option>
              ))}
            </Form.FieldSelect>
          </div>
          {customFields.map((element, index) => {
            // console.log(element);
            return element.deleted ? null : (
              <div className="col-sm-6 col-md-4 col-lg-3">
                {/* Drop Down */}
                {element.type == undefined || element.type == 'Drop Dawn' ? (
                  <Form.FieldSelect
                    error={(isSubmitted && errors.criteria) || {}}
                    name={element.key} //Nombre de como se guardara el Custom field
                    label={element.name}
                    handleChange={dropDownSelected}
                    value={element.value}
                    readOnly={readOnly}
                  >
                    {element.elementsShow
                      ? element.elementsShow.map(
                          //Mapear las opciones del select
                          (option, index) => {
                            if (!option.state_unique || element.value == option.value)
                              return <option value={option.value}>{option.value}</option>;
                          }
                        )
                      : null}
                  </Form.FieldSelect>
                ) : null}
                {/* Numerico y Moneda*/}
                {element.type == 'Numerico' || element.type == 'Moneda' ? (
                  <Form.FieldInput
                    type="number"
                    className="text-right input-table"
                    inputSize="sm"
                    error={(isSubmitted && errors.criteria) || {}}
                    label={element.name}
                    name={element.key}
                    handleChange={(e) => {
                      const value = Number.isNaN(parseFloat(e.target.value))
                        ? ''
                        : parseFloat(e.target.value);
                      const name = e.target.name;
                      handleCustomFieldChange({ target: { name, value } });
                    }}
                    t={t}
                    value={element.value}
                    readOnly={readOnly}
                  />
                ) : null}
                {/* Texto Corto */}
                {element.type == 'Texto Corto' ? (
                  <Form.FieldInput
                    className="text-left input-table"
                    inputSize="sm"
                    error={(isSubmitted && errors.criteria) || {}}
                    label={element.name}
                    name={element.key}
                    handleChange={handleCustomFieldChange}
                    t={t}
                    value={element.value}
                    readOnly={readOnly}
                  />
                ) : null}
                {/* Texto Largo */}
                {element.type == 'Texto Largo' ? (
                  <Form.FieldTextArea
                    className="text-left input-table"
                    inputSize="sm"
                    error={(isSubmitted && errors.criteria) || {}}
                    label={element.name}
                    name={element.key}
                    handleChange={handleCustomFieldChange}
                    t={t}
                    value={element.value}
                    readOnly={readOnly}
                  />
                ) : null}
                {/* Checkbox - Seleccion Unica */}
                {element.type == 'Seleccion Unica' ? (
                  <Form.Checkbox
                    className="icheckbox_flat-blue"
                    // className="text-left input-table"
                    inputSize="sm"
                    error={(isSubmitted && errors.criteria) || {}}
                    label={element.name}
                    name={element.key}
                    onChange={handleCustomFieldChange}
                    t={t}
                    checked={element.value}
                    readOnly={readOnly}
                  />
                ) : null}
                {/* Radio - Seleccion Multiple */}
                {element.type == 'Seleccion Multiple' ? (
                  <Form.Radio
                    className="icheckbox_flat-blue"
                    // className="text-left input-table"
                    inputSize="sm"
                    error={(isSubmitted && errors.criteria) || {}}
                    label={element.name}
                    name={element.key}
                    data={element.elementsShow}
                    onChange={handleCustomFieldChange}
                    t={t}
                    state_unique={element.state_unique}
                    checked={element.value}
                    readOnly={readOnly}
                  />
                ) : null}
                {/* Fecha */}
                {element.type == 'Fecha' ? (
                  <Form.FieldDate
                    className="icheckbox_flat-blue"
                    // className="text-left input-table"
                    inputSize="sm"
                    error={(isSubmitted && errors.criteria) || {}}
                    label={element.name}
                    name={element.key}
                    handleChange={handleCustomFieldChange}
                    t={t}
                    value={element.value}
                    readOnly={readOnly}
                  />
                ) : null}
                {/* Hora */}
                {element.type == 'Hora' ? (
                  <Form.FieldTime
                    className="icheckbox_flat-blue"
                    // className="text-left input-table"
                    inputSize="sm"
                    error={(isSubmitted && errors.criteria) || {}}
                    label={element.name}
                    name={element.key}
                    handleChange={handleCustomFieldChange}
                    t={t}
                    value={element.value}
                    readOnly={readOnly}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default CustomFields;



// WEBPACK FOOTER //
// src/modules/common/components/form/CustomFields.js